import { ErrorState } from '@bp/ui-components';
import { PageLayoutPlaceholder } from 'components/PageLayoutPlaceholder/PageLayoutPlaceholder';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

export const PageNotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <PageLayoutPlaceholder>
      <ErrorState type='notFound' useLightColor onNavigateBack={() => navigate(-1)} showBackButton />
    </PageLayoutPlaceholder>
  );
};
